
                export default function (Component) {
                    Component.__source = "library/layouts/VabLayoutVertical/index.vue"
                }
            